import types from "../actionTypes";

export default function toastComponentReducer(
  state = {
    isSuccessMessage: false,
    isErrorMessage: false,
    isDefaultErrorMessage: false,
    isValidationOccur: false,
    labelKey: undefined,
    message: "Product added successfully",
  },
  action
) {
  switch (action.type) {
    case types.SHOW_SUCCESS_MESSAGE:
      return Object.assign({}, state, {
        isSuccessMessage: action.isSuccessMessage,
        isErrorMessage: action.isErrorMessage,
        message: action.message,
      });
    case types.SHOW_ERROR_MESSAGE:
      return Object.assign({}, state, {
        isErrorMessage: action.isErrorMessage,
        isSuccessMessage: action.isSuccessMessage,
        message: action.message,
      });
    case types.SHOW_VALIDATION_ERROR_MESSAGE:
      return Object.assign({}, state, {
        isErrorMessage: action.isErrorMessage,
        isSuccessMessage: action.isSuccessMessage,
        isValidationOccur: action.isValidationOccur,
        labelKey: action.labelKey,
        message: action.message,
      });
    case types.SHOW_DEFAULT_ERROR_MESSAGE:
      return Object.assign({}, state, {
        isDefaultErrorMessage: action.isDefaultErrorMessage,
        isSuccessMessage: action.isSuccessMessage,
      });
    default:
      return state;
  }
}